import { render, staticRenderFns } from "./sleepBreathe.vue?vue&type=template&id=a6a6cea8&scoped=true&"
import script from "./sleepBreathe.vue?vue&type=script&lang=js&"
export * from "./sleepBreathe.vue?vue&type=script&lang=js&"
import style0 from "./sleepBreathe.vue?vue&type=style&index=0&id=a6a6cea8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a6a6cea8",
  null
  
)

export default component.exports